import { render, staticRenderFns } from "./AppFirstAddress.vue?vue&type=template&id=479a4ee0&scoped=true"
import script from "./AppFirstAddress.vue?vue&type=script&lang=js"
export * from "./AppFirstAddress.vue?vue&type=script&lang=js"
import style0 from "./AppFirstAddress.vue?vue&type=style&index=0&id=479a4ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a4ee0",
  null
  
)

export default component.exports